import { defineStore } from 'pinia'
import type { GetOrganizationsRequestParam } from '@/types/api/dupAuth/getOrganizationsRequestParam'
import type { UserManagement } from '@/types/userManagement/userManagement'
import { ref } from 'vue'
import { format } from 'date-fns'
import type { GetOrganizationUsersRequestParam } from '@/types/api/dupAuth/getOrganizationUsersRequestParam'
import type { UpdateAccountRequestParam } from '@/types/api/dupAuth/updateAccountRequestParam'
import type { SetAccountRequestParam } from '@/types/api/dupAuth/setAccountRequestParam'
import { useWithAuthApi } from '@/api/dupAuth/withAuth/withAuth'

export const useUserManagementStore = defineStore('userManagementStore', () => {
  const userList = ref<UserManagement[]>([])
  const registeredUserId = ref<string | null>(null)
  const { callGetOrganizations, callGetOrganizationUsers, callUpdateAccount, callSetAccount } =
    useWithAuthApi()

  const fetchUserInfoForGovAdmin = async (param: GetOrganizationsRequestParam) => {
    const result = await callGetOrganizations(param)
    userList.value = result.map(item => ({
      ...item,
      userName: item.userName ?? '',
      createAt: format(new Date(item.createAt), 'yyyy/MM/dd HH:mm:ss'),
      lastLoginAt: item.lastLoginAt
        ? format(new Date(item.lastLoginAt), 'yyyy/MM/dd HH:mm:ss')
        : '未ログイン'
    }))
  }

  const fetchUserInfoForOrgAdmin = async (param: GetOrganizationUsersRequestParam) => {
    const result = await callGetOrganizationUsers(param)
    userList.value = result.map(item => ({
      ...item,
      userName: item.userName ?? '',
      createAt: format(new Date(item.createAt), 'yyyy/MM/dd HH:mm:ss'),
      lastLoginAt: item.lastLoginAt
        ? format(new Date(item.lastLoginAt), 'yyyy/MM/dd HH:mm:ss')
        : '未ログイン'
    }))
  }

  const fetchUpdateUserField = async (param: UpdateAccountRequestParam) => {
    await callUpdateAccount(param)
  }

  const fetchSetAccount = async (param: SetAccountRequestParam) => {
    const result = await callSetAccount(param)
    registeredUserId.value = result.userId
  }

  return {
    userList,
    registeredUserId,
    fetchUserInfoForGovAdmin,
    fetchUserInfoForOrgAdmin,
    fetchUpdateUserField,
    fetchSetAccount
  }
})
